import { render, staticRenderFns } from "./IssueTable.vue?vue&type=template&id=48ad3699&scoped=true&"
import script from "./IssueTable.vue?vue&type=script&lang=js&"
export * from "./IssueTable.vue?vue&type=script&lang=js&"
import style0 from "./IssueTable.vue?vue&type=style&index=0&id=48ad3699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ad3699",
  null
  
)

export default component.exports